var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2c1.473 0 2.893.228 4.227.65-1.927.184-4.528.618-5.863 1.471-1.746 1.116-2.627 2.042-2.849 2.365h1.94c-1.233 1.293-3.807 4.266-4.243 5.818-.436 1.551-.182 2.586 0 2.91.323-.486 1.297-1.71 2.606-2.728 1.31-1.018 2.243-1.556 2.546-1.697V7.455c.707.707 2.412 2.242 3.575 2.727l.27.111c1.528.63 4.221 1.742 4.336 3.283.096 1.309-.728 2.606-1.152 3.09-.182-.545-.885-1.37-2.242-.302-1.698 1.333-1.698 3.333-.85 4.181.85.849 2.789 1.152 4.243-1.03 1.164-1.745 1.415-4.687 1.394-5.94l1.272 1.334c.04-.647.012-2.22-.424-3.334-.437-1.115-2.202-2.526-3.03-3.091.323-.06 1.115-.146 1.697 0a30.56 30.56 0 0 0 1.757.363c-.17-1.166-.63-3.068-1.424-4.484A13.986 13.986 0 0 1 30 16zm-11.515-2.485c-.02.202.048.606.485.606.545.001 1.165-.907 0-1.21-1.166-.305-2.687-.203-3.455.12.828-.04 2.582 0 2.97.485z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEz);
export default __webpack_public_path__ + "static/media/EZ.1084c683e0f30c510f78a15104c3ae0c.svg";
export { ForwardRef as ReactComponent };